import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ChatcontFilter'
})
export class ChatcontFilterPipe implements PipeTransform {

  transform(items: any[], cnt: number): any[] {
    if (!items) return [];

   if(cnt==5){
    setTimeout(() => {
      $(".cmcc_message_card").animate({ scrollTop: $(".cmcc_message_card")[0].scrollHeight }, -500);
    });
   }
    return items.slice(-cnt);
  //   if (!searchText ) 
  //   if (!items) return [];
  //  // if (!searchText || searchText.length<=1) return items;
  //   searchText = searchText.toLowerCase();
  //   return items.filter((it) => {
  //     return it.name.toLowerCase().includes(searchText);
  //   });
  }

}
